import styled, { css } from "styled-components";
import InstagramIcon from "./icons/InstagramIcon";
import YouTubeIcon from "./icons/YouTubeIcon";
import GlobeIcon from "./icons/GlobeIcon";
import { useRetractableMenu } from "../context/RetractableMenuContext";
import { INSTAGRAM_URL, YOUTUBE_URL, WEBSITE_URL } from "../constants/links";

const StyledFooter = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;

  color: var(--color-text);
`;

const SocialMedias = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;

  ${(props) =>
    !props.isExpanded &&
    css`
      flex-direction: column;
    `}
`;

const AnchorLink = styled.a``;

function Footer() {
  const { isExpanded } = useRetractableMenu();
  return (
    <StyledFooter>
      <SocialMedias isExpanded={isExpanded}>
        <AnchorLink
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <InstagramIcon />
        </AnchorLink>

        <AnchorLink
          href={YOUTUBE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
        >
          <YouTubeIcon />
        </AnchorLink>

        <AnchorLink
          href={WEBSITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Benthos website"
        >
          <GlobeIcon />
        </AnchorLink>
      </SocialMedias>
    </StyledFooter>
  );
}

export default Footer;
